import React from 'react';
import { useProjectConfigContext } from '../../../../../contexts/ProjectConfigContext';
import { usePermitRequestContext } from '../../../../../contexts/PermitRequestContext';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import PermitType from '../../../../../types/permit.type';
import addRequestPageLang from '../../../../../data/lang/add-request-page.lang';
import { useTags } from '../../../../../hooks/useTags';


type Props = {
    handleClick: (e: React.MouseEvent<HTMLInputElement>) => void
}

const BusinessPermitType = ({ handleClick }: Props) => {

    const { projectConfigState } = useProjectConfigContext();
    const { Formik } = usePermitRequestContext();
    const generateTag = useTags();
    const { values } = Formik;
    const permitType = values.permitType;

    const permitTypes = projectConfigState.addRequestPageConfig.permitTypes;

    const label = generateTag(addRequestPageLang, 'form.permit-types.business-permit.title-tag');;
    const noLabel = generateTag(addRequestPageLang, 'form.permit-types.business-permit.options.noLabel');
    const yesLabel = generateTag(addRequestPageLang, 'form.permit-types.business-permit.options.yesLabel');

    if (!permitTypes.business) {
        return null;
    }

    return (
        <div className='row'>
            <div className='col-12 col-sm-4'>
                <RadioBtnsContainer label={label}>

                    <RadioOutlineBtn
                        isChecked={permitType !== PermitType.BUSINESS}
                        label={noLabel}
                        value={PermitType.REGULAR}
                        onClick={handleClick}
                        id="businessPermitNo"
                        name='businessPermit'
                    />

                    <RadioOutlineBtn
                        isChecked={permitType === PermitType.BUSINESS}
                        label={yesLabel}
                        value={PermitType.BUSINESS}
                        onClick={handleClick}
                        id="businessPermitYes"
                        name='businessPermit'
                    />

                </RadioBtnsContainer>
            </div>
        </div>
    );
}

export default BusinessPermitType;